<ion-list class="ion-hide-md-down">
  <ion-menu-toggle autoHide="false">
    <ion-item
      button
      routerLink="/tabs/dashboard"
      routerLinkActive="active"
      routerDirection="root"
      detail="false"
    >
      <ion-icon
        aria-hidden="true"
        src="../assets/material-symbols/dashboard_24dp_FILL0_wght400_GRAD0_opsz24.svg"
        slot="start"
      ></ion-icon>
      <ion-label>Dashboard</ion-label>
    </ion-item>
  </ion-menu-toggle>
  @if ((userCapabilities$ | async)?.includes(ECapabilities.UPLOAD_FREIGHTS)) {
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/tabs/freight-ship-pending"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/okcargo-upload-freights.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.pending' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>

    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/tabs/freight-ship-inprogress"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/okcargo-shipper-inprogress.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.in_progress' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>

    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/tabs/freight-ship-finished"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/okcargo-shipper-finished.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.finished' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>
  }
</ion-list>

<ion-list>
  @if ((userCapabilities$ | async)?.includes(ECapabilities.ADMINISTRATIVE_DOCUMENTS)) {
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/my-company"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/domain_24dp_FILL0_wght400_GRAD0_opsz24.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'company.my_company' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>

    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/billing-shipper"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/payments_24dp_FILL0_wght400_GRAD0_opsz24.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.billing' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>
  }

  @if ((userCapabilities$ | async)?.includes(ECapabilities.CRUD_USERS)) {
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/users"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/group_24dp_FILL0_wght400_GRAD0_opsz24.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.users' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>
  }
  @if ((userCapabilities$ | async)?.includes(ECapabilities.UPLOAD_FREIGHTS)) {
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/sustainability"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/potted_plant_24dp_FILL0_wght400_GRAD0_opsz24.svg"
          slot="start"
        ></ion-icon>
        <ion-label>Sostenibilidad</ion-label>
      </ion-item>
    </ion-menu-toggle>
  }
</ion-list>

<ion-list>
  <ion-menu-toggle autoHide="false">
    <ion-item
      button
      routerLink="/account"
      routerLinkActive="active"
      routerDirection="root"
      detail="false"
    >
      <ion-icon
        aria-hidden="true"
        src="../assets/material-symbols/account_circle_FILL0_wght400_GRAD0_opsz24.svg"
        slot="start"
      ></ion-icon>
      <ion-label>{{ 'general.nav_bar.account' | translate }}</ion-label>
    </ion-item>
  </ion-menu-toggle>
</ion-list>
